import { MutationTree } from "vuex";
import { AuthState } from "./state";

export enum AuthMutationTypes {
  SetUser = "SET_USER",
  SetGroups = "SET_GROUPS",
  SetTokens = "SET_TOKENS",
  SetName = "SET_NAME",
  PurgeAuth = "PURGE_AUTH",
}

type Tokens = {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  exp?: number;
};

export type AuthMutations = {
  [AuthMutationTypes.SetUser](state: AuthState, user: any): void;
  [AuthMutationTypes.SetTokens](state: AuthState, tokens: Tokens): void;
  [AuthMutationTypes.SetName](state: AuthState, name: string): void;
  [AuthMutationTypes.SetGroups](state: AuthState, groups: Array<string>): void;
  [AuthMutationTypes.PurgeAuth](state: AuthState): void;
};

export const mutations: MutationTree<AuthState> & AuthMutations = {
  [AuthMutationTypes.SetUser](state, user) {
    state.user = user;
  },
  [AuthMutationTypes.SetGroups](state, groups) {
    state.groups = groups;
  },
  [AuthMutationTypes.SetTokens](state, tokens) {
    state.idToken = tokens.idToken;
    state.accessToken = tokens.accessToken;
    state.refreshToken = tokens.refreshToken;
    state.exp = tokens.exp;
  },
  [AuthMutationTypes.SetName](state, name) {
    state.name = name;
  },
  [AuthMutationTypes.PurgeAuth](state) {
    state.idToken = "";
    state.accessToken = "";
    state.refreshToken = "";
    state.name = "";
    state.user = null;
    state.exp = 0;
    state.groups = [];
  },
};